export enum RedirectUrlType {
    CONFIRM = "confirm",
}

export enum RedirectUrlFrom {
    PAYMENT_LYRA = "pay_lyra",
    ORDER_SAGA = "order_saga",
    PAYMENT_LYF = "pay_lyf",
}

export interface RedirectUrl {
    url: string;
    replaceHistory: boolean;
    type?: RedirectUrlType;
    from?: RedirectUrlFrom;
}